// Route path constants

export const ROUTES = {
  // Public
  HOME: '/',
  PUBLIC_TREE: (token: string) => `/public-tree/${token}`,

  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',

  // Onboarding
  ONBOARDING: '/onboarding',
  ONBOARDING_STEP_2: '/onboarding/step-2',
  ONBOARDING_STEP_3: '/onboarding/step-3',
  ONBOARDING_STEP_4: '/onboarding/step-4',
  ONBOARDING_STEP_5: '/onboarding/step-5',
  ONBOARDING_SUCCESS: '/onboarding/success',

  // Dashboard
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',

  // Trees
  TREES: '/trees',
  TREE_DETAIL: (id: string) => `/trees/${id}`,
  TREE_SETTINGS: (id: string) => `/trees/${id}/settings`,
  TREE_VISUALIZATION: (id: string) => `/trees/${id}/visualization`,

  // Persons
  PERSONS: (treeId: string) => `/trees/${treeId}/persons`,
  PERSON_DETAIL: (treeId: string, personId: string) =>
    `/trees/${treeId}/persons/${personId}`,

  // Relationships
  RELATIONSHIPS: (treeId: string) => `/trees/${treeId}/relationships`,

  // Exports
  EXPORTS: (treeId: string) => `/trees/${treeId}/exports`,

  // Imports
  IMPORTS: (treeId: string) => `/trees/${treeId}/imports`,

  // Admin
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_SETTINGS: '/admin/settings'
} as const;
